import { Button, Skeleton, Tooltip } from "antd";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";
import Container from "../../../General/Container/Container";
import { HiOutlineLightBulb } from "react-icons/hi";
import TableProgress from "../../../General/TableProgress";

function WhiteSpaceSummaryTopItem({
    type = "whitespace",
    title,
    list = [],
    onClickItem = () => { },
    loading
}) {
    const getParentPath = (obj) => {
        return obj.parentPath.split("/").map((path) => {
            return path.split("~~")[1]
        }).join("/")
    }
    const getColor = () => type === "whitespace" ? "#00C18D" : "#2563EB"
    const getSubColor = () => type === "whitespace" ? "#D1FAE5" : "#DBEAFE"
    const columns = [
        {
            title: "Insights",
            key: "insights",
            width: 70,
            align: "center",
            render: (value, row) => {
                return <Button
                    type="link"
                    onClick={() => {
                        onClickItem(row.name, row);
                    }}
                    icon={<HiOutlineLightBulb style={{
                        fontSize: "5mm", color: getColor(),
                        cursor: "pointer"
                    }} />}
                />
            }
        },
        {
            title: "Segments",
            key: "name",
            render: (value, row) => {
                return <Container className="dcol">
                    <span
                        style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "var(--bluegray-600)"
                        }}>
                        {value}
                    </span>
                    <span
                        style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "var(--bluegray-400)"
                        }}>
                        {getParentPath(row)}
                    </span>
                </Container>
            }
        },
        {
            title: "Score",
            key: "newFormulaScore",
            align: "right",
            width: 150,
            render: (value) => {
                return <TableProgress
                    value={value / 100}
                    color={getColor()}
                    backgroundColor={getSubColor()}
                />
            }
        },
    ]

    return <Container className={"whitespace-summarywithtext-item dcol flex-1 gap-2 " + type}>
        <span className="whitespace-summarywithtext-title">{title}</span>
        <Container className="whitespace-summarywithtext-cont dcol gap-5p">
            {loading
                ? <Skeleton paragraph={{ rows: 6 }} active />
                : <CustomTable
                    style={{ width: "98%" }}
                    noCheckbox
                    pagination={false}
                    columns={columns}
                    dataSource={list}
                    numColProps={{
                        width: 40
                    }}
                />}
        </Container>
    </Container>
}

export default WhiteSpaceSummaryTopItem;
